/** @file unprojectScreen: a screen offset plus a view depth back to a display-space offset (ortho inverse). */
import type { OrthoBasis } from '@zilo/pose3d-math/project/orthoBasis';
import type { Vec3 } from '@zilo/pose3d-math/vec3/vec3';

/**
 * Inverse of math `projectOrtho`: screen offset `(dx, dy)` in px (y down) from the view target and view `depth` in
 * units (grows away) -> `right * dx / ppu - up * dy / ppu - back * depth` in display space.
 */
export function unprojectScreen(dx: number, dy: number, depth: number, basis: OrthoBasis, pixelsPerUnit: number): Vec3 {
  const x = dx / pixelsPerUnit;
  const y = dy / pixelsPerUnit;
  const { right, up, back } = basis;
  return [
    right[0] * x - up[0] * y - back[0] * depth,
    right[1] * x - up[1] * y - back[1] * depth,
    right[2] * x - up[2] * y - back[2] * depth,
  ];
}
